<div class="content" style="width: 780px;">
    <div style="display: flex; flex-direction: row; width: 100%;">
        <h1 style="color: #FF0000;">{{viewModel.applicationName}}</h1>
        <button matTooltip="Copy to Clipboard" style="margin-left: auto;" mat-button (click)="copyToClipboard(reportContent)">
            <mat-icon color="primary">content_copy</mat-icon>
        </button>
    </div>
    <div #reportContent>
        <div style="color: #FF0000; ">Report Id: {{viewModel.errorReportId}}</div>
        <div style="color: #FF0000; ">Create Date: {{viewModel.createdDateTime}}</div>
        <br>
        <br>
        <pre style="color: #D9D9D9; font-family: Roboto Mono;">{{viewModel.errorReport.errorMessage}}</pre>
    </div>
</div>